<template>
  <div class="faqs">
    <div class="faqs__container">
      <h2
        v-if="items.length"
        class="faqs__title"
      >
        {{ $t('b2b_static_frequently_asked_questions_title') }}
      </h2>
      <Accordion :items="items" />
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watchEffect } from 'vue'
import useUserStore from '@shared/stores/useUserStore.js'
import { getHelpscoutFaqs } from '@shared/api-endpoints'
import Accordion from '@shared/components/Accordion.vue'

const userStore = useUserStore()

const items = ref([])
const lang = computed(() => userStore.lang)

watchEffect(async () => {
  const { data } = await getHelpscoutFaqs(lang.value)
  items.value =
    data?.faqs?.map(({ title, text }) => ({ title, content: text })) ?? []
})
</script>

<style lang="scss">
.faqs {
  background-color: $kds-color-background-blue-subtle;

  &__container {
    padding: 56px $kds-space-3x 0;
    @include padding(xxl, y);
    max-width: 1000px;
    margin: auto;
  }

  &__title {
    @include kds-typography-display-small;
    font-weight: $kds-typography-font-weight-medium;
    margin-bottom: $kds-space-3x;
    text-align: center;

    @include media-up(md) {
      @include kds-typography-display-medium;
      font-weight: $kds-typography-font-weight-medium;
      margin-bottom: $kds-space-3x;
    }
  }
}
</style>
